module.exports = __webpack_public_path__ + "img/eyes_female_round_makeup.bbd2ff16.png";